import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORMS]: {
		url: '/company/:companyId/works_quality_norms/',
	},

	[ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORM]: {
		url: '/company/:companyId/works_quality_norms/:worksQualityNormId/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].CREATE_WORKS_QUALITY_NORM]: {
		url: '/company/:companyId/works_quality_norms/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PUT_WORKS_QUALITY_NORM]: {
		url: '/company/:companyId/works_quality_norms/:worksQualityNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PATCH_WORKS_QUALITY_NORMS]: {
		url: '/company/:companyId/works_quality_norms/:worksQualityNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].DELETE_WORKS_QUALITY_NORM]: {
		url: '/company/:companyId/works_quality_norms/:worksQualityNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}